// A team's page (A5U14), owned by hand: the loader warms the team through the same queryOptions the screen reads.
import { ids } from '@orca/api-client/testIds'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { teamQuery } from '../../../../../features/teams/queries'
import '../../../../../features/teams/strings'
import { TeamDetail } from '../../../../../features/teams/TeamDetail'
import { accessQuery, can, useCan } from '../../../../../shared/access/access'
import { Part } from '../../../../../shared/shell/StatePart'

export const Route = createFileRoute('/o/$orgSlug/people/teams/$teamId')({
  staticData: { screenId: 'TeamDetailScreen', access: 'team.read' },
  loader: async ({ context: { queryClient, membership }, params }) => {
    const access = await queryClient.ensureQueryData(accessQuery(membership.orgId)).catch(() => null)
    if (can(access, 'team.read')) await queryClient.ensureQueryData(teamQuery(membership.orgId, params.teamId))
    return { orgId: membership.orgId }
  },
  component: TeamDetailScreen,
})

function TeamDetailScreen() {
  const { t } = useTranslation()
  const { orgId } = Route.useLoaderData()
  const { orgSlug, teamId } = Route.useParams()
  const canRead = useCan(orgId, 'team.read')
  return (
    <main data-testid={ids.teamDetail.root}>
      {canRead ? (
        <Part testId={ids.teamDetail.skeleton}>
          <TeamDetail orgId={orgId} orgSlug={orgSlug} teamId={teamId} />
        </Part>
      ) : (
        <p role="alert">{t('teams.detail.refused')}</p>
      )}
    </main>
  )
}
